/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
import moment from 'moment';

class FriendlyTimestamp {
  static parse(timestamp) {
    if (window.I18n != null) { moment.locale(I18n.locale); }
    // services api sends timestamps as unix numbers, v1 api sends them in standard string format
    const parsedTimestamp = typeof timestamp === 'number' ? moment.unix(timestamp) : moment(timestamp);
    if (parsedTimestamp.isBefore(moment().subtract(2, 'days'))) {
      return parsedTimestamp.format('D MMMM YYYY');
    } else {
      return parsedTimestamp.fromNow(true);
    }
  }
}

$.fn.friendlyTimestamp = function() {
  return this.each(function() {
    return $(this).text(FriendlyTimestamp.parse($(this).data('timestamp')));
  });
};

export default FriendlyTimestamp;
